"use strict";

var _classCallCheck = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _web = _interopRequireDefault(require("web3"));

var _FDSAccount = _interopRequireDefault(require("./FDS-Account"));

var _FDSTx = _interopRequireDefault(require("./FDS-Tx"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FDS =
/*#__PURE__*/
function () {
  _createClass(FDS, [{
    key: "defaultConfig",
    value: function defaultConfig() {
      return {
        tokenName: 'gas',
        swarmGateway: 'https://swarm2.fairdatasociety.org',
        ethGateway: 'https://geth-noordung.fairdatasociety.org',
        faucetAddress: 'https://faucet-noordung.fairdatasociety.org/gimmie',
        chainID: '235813',
        httpTimeout: 1000,
        gasPrice: 0.1,
        walletVersion: 1,
        ensConfig: {
          domain: 'datafund.eth',
          registryAddress: '0xA1029cb176082eca658A67fD6807B9bDfB44A695',
          subdomainRegistrarAddress: '0x0E6a3B5f6800145bAe95C48934B7b5a90Df50722',
          resolverContractAddress: '0xC91AB84FFad79279D47a715eF91F5fbE86302E4D'
        }
      };
    }
  }]);

  function FDS() {
    _classCallCheck(this, FDS);

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (config === false) {
      config = this.defaultConfig();
    }

    config.web3 = new _web.default(new _web.default.providers.HttpProvider(config.ethGateway, config.httpTimeout), null, {
      transactionConfirmationBlocks: 1
    });
    this.ethGateway = config.ethGateway;
    this.swarmGateway = config.swarmGateway;
    this.currentAccount = null;
    this.Account = new _FDSAccount.default(config);
    this.Tx = new _FDSTx.default(config); // this.Utils = Utils;
    // this.Crypto = Crypto;
  }
  /**
   * Retrieves accounts stored in localstorage.
   * @GetAccounts
   * @returns {any} all accounts
   */


  _createClass(FDS, [{
    key: "GetAccounts",
    value: function GetAccounts(walletVersion) {
      return this.Account.getAll(walletVersion);
    }
    /**
     * Creates an FDS account with associated ENS name and stores the account info in localstorage.
     * @CreateAccount
     * @param {string} subdomain - the subdomain of the ENS record.
     * @param {string} password - password for wallet encryption.
     * @param {any} feedbackMessageCallback callback
     * @returns {promise} outcome of attempt to create account, Account object or error.      
     */

  }, {
    key: "CreateAccount",
    value: function CreateAccount(subdomain, password) {
      var feedbackMessageCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : console.log;
      return this.Account.create(subdomain, password, feedbackMessageCallback).then(function (account) {
        return account;
      });
    }
    /**
     * Retrieves an FDS account from localstorage unlocks, and sets as context.
     * @get
     * @param {string} subdomain name
     * @param {string} password to use
     * @returns {boolean} true if successful
     */

  }, {
    key: "UnlockAccount",
    value: function UnlockAccount(subdomain, password) {
      var _this = this;

      return this.currentAccount = this.Account.unlock(subdomain, password).then(function (account) {
        _this.currentAccount = account;
        return _this.currentAccount;
      });
    }
    /**
     * Removes an FDS account from localstorage.
     * @deleteAccount
     * @param {string} subdomain - the subdomain of the configured ENS domain.
     * @returns {boolean} true if successful
     */

  }, {
    key: "DeleteAccount",
    value: function DeleteAccount(subdomain) {
      // if the account exists locally
      // delete it
      return this.Account.delete(subdomain);
    }
    /**
     * Removes unlocked keys from memory.
     * @get
     * @param {string} subdomain name
     */

  }, {
    key: "LockAccount",
    value: function LockAccount(subdomain) {
      // retrieve account
      // unlock it
      this.currentAccount = null;
    }
    /**
     * Restores an FDS account from a string.
     * @get
     * @param {string} file wallet in JSON
     * @returns {boolean} true if successful
     */

  }, {
    key: "RestoreAccount",
    value: function RestoreAccount(file) {
      return this.Account.restoreFromFile(file);
    }
    /**
     * Restores an FDS account from a string.
     * @get
     * @param {string} file wallet in JSON
     * @returns {boolean} true if successful
     */

  }, {
    key: "RestoreAccountFromJSON",
    value: function RestoreAccountFromJSON(subdomain, json) {
      return this.Account.restore(subdomain, json);
    }
    /**
     * Restores an FDS account from a private key.
     * @get
     * @param {string} private key as a hex string
     * @returns {boolean} true if successful
     */

  }, {
    key: "RestoreAccountFromPrivateKey",
    value: function RestoreAccountFromPrivateKey(subdomain, password, privateKey) {
      return this.Account.restoreFromPrivateKey(subdomain, password, privateKey);
    }
    /**
     * Intigates download of a FDS wallet backup file.
     * @get
     * @param {string} subdomain name
     * @returns {boolean} true if successful
     */

  }, {
    key: "BackupAccount",
    value: function BackupAccount(subdomain) {
      return this.Account.get(subdomain).saveBackupAs();
    }
    /**
     * Intigates download of FDS wallet backup JSON.
     * @get
     * @param {string} subdomain name
     * @returns {boolean} true if successful
     */

  }, {
    key: "BackupAccountAsJSON",
    value: function BackupAccountAsJSON(subdomain) {
      return this.Account.get(subdomain).getBackupAsJSON();
    }
  }]);

  return FDS;
}();

var _default = FDS;
exports.default = _default;
module.exports = exports.default;